import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Footer from "../../../components/footer/Footer";
import Scrollbar from "../../../components/scrollbar/scrollbar";

import "./AnalogMixedSignal.css";
import "./AnalogTheme.css";
import analogImage from "../../../images/about/testing.jpg";

type Block = { title?: string; text?: string; lines?: string[]; raw: string };

const config = {
  "title": "Analog & Mixed Signal Design & Layout",
  "category": "Advanced Design & Implementation",
  "visual": "analog",
  "folder": "AnalogMixedSignal",
  "sections": [
    [
      "Analog & Mixed Signal Design & Layout",
      "Engineering Precision for Complex Analog & Mixed Signal Systems",
      "Analog and mixed-signal design lies at the intersection of precision engineering and semiconductor innovation. From power management and sensor interfaces to high-speed data conversion and communication systems, these designs demand deep domain expertise, meticulous implementation, and uncompromising attention to performance, noise, power, and signal integrity.",
      "Digicomm Semiconductor delivers specialized Analog & Mixed Signal Design & Layout services that support the development of high-performance integrated circuits across diverse semiconductor applications. Working closely with customer engineering teams, we help transform complex analog design requirements into reliable, implementation-ready solutions through disciplined engineering execution and proven technical expertise.",
      "Primary CTA",
      "Discuss Your Analog Design Requirements"
    ],
    [
      "Capability Overview\n\nAnalog and mixed-signal design plays a critical role in bridging the physical and digital worlds within modern semiconductor products. It enables the accurate processing of real-world signals, efficient power management, high-speed data conversion, and reliable communication between analog interfaces and complex digital systems. As semiconductor technologies continue to advance, achieving optimal performance requires a careful balance of precision, stability, power efficiency, signal integrity, and layout excellence.\n\nDigicomm Semiconductor provides specialized Analog & Mixed Signal Design & Layout capabilities that support the complete development of analog and mixed-signal building blocks across diverse semiconductor applications. From architectural design and circuit implementation to custom layout and design optimization, our engineering teams collaborate closely with customer organizations to develop reliable, high-performance solutions that are implementation-ready and aligned with demanding product requirements."
    ],
    [
      "Why It Matters\nAnalog and mixed-signal circuits form the critical interface between the physical world and digital intelligence. They enable semiconductor devices to capture, process, regulate, and transmit real-world signals with accuracy and stability. As semiconductor products continue to integrate higher levels of functionality, achieving optimal analog performance becomes increasingly important to ensure signal integrity, power efficiency, noise immunity, and overall system reliability.\n\nEffective Analog & Mixed Signal Design & Layout requires a careful balance of circuit performance, physical implementation, and manufacturing considerations. Precision engineering at this stage contributes directly to robust product performance, minimizes downstream design iterations, and supports successful silicon realization.\n\nKey Outcomes:\nEnables Accurate Signal Processing\nDevelop robust analog interfaces that capture and process real-world signals with precision and reliability.\n\nOptimizes Power Efficiency\nDesign analog circuits that balance performance with efficient power consumption across diverse operating conditions.\n\nStrengthens Signal Integrity\nMinimize noise, interference, and signal degradation to improve overall system performance and stability.\n\nSupports High-Performance Integration\nEnable seamless interaction between analog and digital domains within increasingly complex semiconductor architectures.\n\nImproves Design Reliability\nApply disciplined analog design and layout practices that contribute to predictable behavior, implementation quality, and manufacturing readiness.\n\nContributes to Reliable Silicon Outcomes\nBuild high-performance analog and mixed-signal designs that strengthen overall product quality and support successful silicon realization."
    ],
    [
      "Analog & Mixed Signal Engineering Scope:\nAnalog Circuit Design\nDesign of precision analog circuits that meet demanding performance, power, noise, linearity, and reliability requirements across a wide range of semiconductor applications.\n\nMixed Signal Design\nDevelopment of mixed-signal architectures that enable seamless interaction between analog interfaces and complex digital systems while maintaining signal accuracy and system performance.\n\nCustom Layout Design\nCreation of optimized custom layouts that preserve analog performance through careful device matching, parasitic control, noise isolation, and layout-aware engineering practices.\n\nData Converter Design\nEngineering support for Analog-to-Digital Converters (ADC), Digital-to-Analog Converters (DAC), and associated interface circuits that require high accuracy and performance.\n\nPower Management Circuits\nDesign of analog power management building blocks supporting voltage regulation, power efficiency, low-power operation, and reliable system performance.\n\nHigh-Speed Interface Circuits\nDevelopment of precision analog interfaces supporting high-speed communication, clock distribution, signal conditioning, and advanced semiconductor connectivity.\n\nDesign Optimization\nOptimization of analog and mixed-signal designs to improve performance, power consumption, silicon area, manufacturability, and long-term product reliability.\n\nLayout Verification & Sign-off Support\nSupport for layout verification, physical validation, and implementation readiness to ensure design integrity before fabrication."
    ],
    [
      "Key Benefits\nSuccessful Analog & Mixed Signal Design requires far more than circuit expertise. It demands a deep understanding of device behavior, physical implementation, signal integrity, and system-level interactions. Digicomm's Analog & Mixed Signal Design & Layout capabilities help organizations develop precision-engineered solutions that improve product performance, strengthen implementation confidence, and support reliable semiconductor outcomes.\n\nPrecision Analog Performance\nDevelop high-performance analog circuits engineered for accuracy, stability, and dependable operation across demanding application environments.\n\nOptimized Power Efficiency\nDesign analog building blocks that balance performance with efficient power consumption to support modern low-power semiconductor products.\n\nEnhanced Signal Integrity\nReduce noise, interference, and signal degradation through disciplined analog design, custom layout, and optimization practices.\n\nReliable Mixed-Signal Integration\nEnable seamless interaction between analog and digital domains, improving overall system functionality and design robustness.\n\nImproved Implementation Confidence\nApply structured engineering and layout methodologies that strengthen manufacturability, design quality, and implementation readiness.\n\nPredictable Silicon Outcomes\nSupport reliable silicon realization through precision analog engineering, disciplined execution, and a strong focus on product quality."
    ],
    [
      "Technology Expertise",
      "Developing high-performance analog and mixed-signal integrated circuits requires deep expertise across precision circuit design, custom layout practices, interface technologies, and performance optimization. Digicomm's Analog & Mixed Signal Design & Layout teams combine strong engineering fundamentals with practical implementation experience to support reliable, scalable, and high-performance semiconductor products across diverse application domains.\n\nAnalog Design Domains\nPrecision Analog Design\nMixed-Signal Circuit Design\nPower Management Circuits\nSignal Conditioning Circuits\nSensor Interface Design\nCircuit Building Blocks\nOperational Amplifiers (Op-Amps)\nComparators\nBandgap References\nVoltage Regulators (LDO)\nPhase-Locked Loops (PLL)\nAnalog-to-Digital Converters (ADC)\nDigital-to-Analog Converters (DAC)\nLayout & Design Practices\nCustom Analog Layout\nDevice Matching Techniques\nParasitic Extraction Awareness\nNoise Isolation & Shielding\nFloorplanning for Analog Blocks\nLayout Optimization\nInterface Technologies\nHigh-Speed Analog Interfaces\nData Converter Interfaces\nSensor Interfaces\nPower Management Interfaces\nMixed-Signal Integration\nEDA Environment (Include only platforms actively used by Digicomm)\nCadence\nSynopsys\nSiemens EDA"
    ],
    [
      "Why Digicomm\nAnalog & Mixed Signal Design demands exceptional engineering precision, deep domain expertise, and disciplined execution. Every design decision influences signal integrity, power efficiency, performance, manufacturability, and long-term product reliability. Digicomm combines specialized analog engineering expertise with structured development methodologies and collaborative execution to help customers build high-performance analog and mixed-signal solutions with confidence.\n\nWhat Sets Us Apart:\nSpecialized Analog Expertise\nDedicated engineering capabilities across analog circuit design, mixed-signal integration, custom layout, and precision implementation for complex semiconductor applications.\n\nPrecision Engineering\nStructured engineering methodologies focused on accuracy, signal integrity, performance optimization, and reliable analog circuit implementation.\n\nLayout-Aware Design Excellence\nA holistic approach that considers circuit performance alongside custom layout practices, parasitic effects, device matching, and manufacturability from the earliest stages of development.\n\nCollaborative Engineering\nEngineering teams that integrate seamlessly with customer organizations through transparent communication, technical alignment, and shared execution ownership.\n\nCommitment to Reliable Silicon\nA disciplined engineering approach focused on delivering robust analog and mixed-signal designs that contribute to predictable implementation and reliable silicon outcomes.\n"
    ],
    [
      "Related Specialized Engineering Capabilities:\nStatic Timing Analysis (STA)\nComprehensive timing analysis and optimization that supports timing closure, implementation quality, and predictable silicon performance.\nLearn More →\n\nFPGA Engineering\nFPGA architecture, implementation, prototyping, and validation supporting accelerated hardware development and functional evaluation.\nLearn More →\n\nRelated Core Engineering Services:\nASIC & SoC Design\nDevelop robust digital architectures that integrate seamlessly with analog and mixed-signal subsystems.\nLearn More →\n\nPhysical Design\nSupport optimized implementation, custom layout integration, and manufacturable silicon through disciplined physical design practices.\nLearn More →\n\nRelated Engineering Engagement Models\nEngineering Consulting\nAccess specialized analog engineering expertise to address complex technical challenges and accelerate development programs.\nLearn More →\n\nDedicated Engineering Teams\nExtend your engineering organization with experienced analog and mixed-signal specialists who integrate seamlessly into ongoing semiconductor programs.\nLearn More →"
    ],
    [
      "Let's Engineer Precision into Every Signal\nFrom precision analog interfaces and mixed-signal architectures to custom layout and implementation optimization, successful analog design demands specialized expertise, disciplined engineering, and close technical collaboration.\n\nWhether you're developing a new semiconductor product, enhancing an existing design, or augmenting your engineering capabilities with specialized analog expertise, Digicomm Semiconductor is ready to support your team with focused engineering competency, collaborative execution, and dependable delivery.\n\nPrimary CTA\nDiscuss Your Analog Design Requirements"
    ]
  ]
} as const;

const splitBlocks = (raw: string): string[] =>
  raw.split(/\n\s*\n/g).map((x) => x.trim()).filter(Boolean);

const asBlock = (raw: string): Block => {
  const lines = raw.split("\n").map((x) => x.trim()).filter(Boolean);
  if (lines.length >= 2 && lines[0].length <= 74) {
    const rest = lines.slice(1);
    const listLike = rest.length >= 3 && rest.every((x) => x.length < 78);
    if (listLike) return { title: lines[0], lines: rest, raw };
    return { title: lines[0], text: rest.join(" "), raw };
  }
  if (lines.length === 1) return { text: lines[0], raw };
  return { text: lines.join(" "), raw };
};

const getHero = (section: readonly string[], pageTitle: string) => {
  const merged = section.join("\n\n");
  const blocks = splitBlocks(merged);
  const filtered = blocks.filter((x) => x !== "Primary CTA");
  if (filtered[0] === pageTitle) filtered.shift();

  const first = filtered.shift() || pageTitle;
  const firstLines = first.split("\n").map((x) => x.trim()).filter(Boolean);
  const headline = firstLines[0] || pageTitle;
  const body: string[] = [];

  if (firstLines.length > 1) body.push(firstLines.slice(1).join(" "));
  filtered.forEach((b) => body.push(b));

  let cta = "";
  if (body.length && body[body.length - 1].length < 85) cta = body.pop() || "";
  return { headline, body, cta };
};

const Arrow = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M5 12h13M13 7l5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EngineeringVisual: React.FC = () => (
  <div className="ses-visual analog-engineering-image">
    <img src={analogImage} alt="Precision semiconductor testing with signal waveforms and wafer probing equipment" />
  </div>
);
const ContentPanel: React.FC<{ raw: string; index: number }> = ({ raw, index }) => {
  const blocks = splitBlocks(raw).filter((x) => x !== "Primary CTA");
  return (
    <div className="ses-block-grid">
      {blocks.map((rawBlock, i) => {
        const block = asBlock(rawBlock);
        const long = rawBlock.length > 430;
        const labelOnly =
          !block.title &&
          !!block.text &&
          block.text.length < 80 &&
          (/[:：]$/.test(block.text) || i === 0);

        return (
          <article
            className={`ses-block ${long ? "ses-block--wide" : ""} ${labelOnly ? "ses-block--label" : ""}`}
            key={`${index}-${i}`}
          >
            {block.title && <h3>{block.title}</h3>}
            {block.text && (labelOnly ? <h3>{block.text}</h3> : <p>{block.text}</p>)}
            {block.lines && <ul>{block.lines.map((line) => <li key={line}>{line}</li>)}</ul>}
          </article>
        );
      })}
    </div>
  );
};

const RelatedPanel: React.FC<{ raw: string }> = ({ raw }) => {
  const blocks = splitBlocks(raw);
  const routeMap: Record<string, string> = {
    "Analog & Mixed Signal Design & Layout": "/services/analog-mixed-signal",
    "Analog & Mixed Signal": "/services/analog-mixed-signal",
    "Static Timing Analysis (STA)": "/services/static-timing-analysis",
    "FPGA Engineering": "/services/fpga-engineering",
    "Embedded Software Systems": "/services/embedded-software-systems",
    "Hardware Platform Engineering": "/services/hardware-platform-engineering",
    "Networking Solutions": "/services/networking-solutions",
    "Silicon Validation": "/services/silicon-validation",
    "EDA & Design Automation": "/services/eda-design-automation",
    "Product Engineering": "/services/product-engineering",
    "ASIC & SoC Design": "/services/asic-soc-design",
    "Physical Design": "/services/physical-design",
    "Verification Services": "/services/verification",
  };

  const cards: React.ReactNode[] = [];
  let group = "";

  blocks.forEach((b, i) => {
    if (/^Related .*:$/.test(b.trim())) {
      group = b.trim();
      return;
    }
    if (b === "Learn More →") return;

    const lines = b.split("\n").map((x) => x.trim()).filter(Boolean);
    const title = lines[0];
    const desc = lines.slice(1).join(" ");

    if (routeMap[title]) {
      cards.push(
        <Link className="ses-related-card" to={routeMap[title]} key={`${title}-${i}`}>
          <span>{group}</span>
          <h3>{title}</h3>
          {desc && <p>{desc}</p>}
          <em>Learn More <Arrow/></em>
        </Link>
      );
    } else {
      cards.push(
        <article className="ses-related-card" key={`${title}-${i}`}>
          <span>{group}</span>
          <h3>{title}</h3>
          {desc && <p>{desc}</p>}
        </article>
      );
    }
  });

  return <div className="ses-related-grid">{cards}</div>;
};

const Page: React.FC = () => {
  const sections = config.sections as readonly (readonly string[])[];
  const hero = getHero(sections[0] || [], config.title);

  const lastSection = sections[sections.length - 1] || [];
  const lastRaw = lastSection.join("\n\n");
  const lastBlocks = splitBlocks(lastRaw).filter((x) => x !== "Primary CTA");
  const ctaLabel =
    lastBlocks.length && lastBlocks[lastBlocks.length - 1].length < 90
      ? lastBlocks[lastBlocks.length - 1]
      : "";
  const ctaContent = ctaLabel ? lastBlocks.slice(0, -1) : lastBlocks;
  const hasRelated = sections.length === 9;

  useEffect(() => {
    document.title = `${config.title} | Digicomm Semiconductor`;
  }, []);

  return (
    <Fragment>
      <div className={`specialized-service-page inner-page analog-redesign`}>
        <div className="body_wrap o-clip">
          <Header />

          <main>
            <PageTitle pageTitle={config.title} pagesub={config.title} />

            <section className="ses-hero">
              <div className="ses-shell ses-two-col">
                <div className="ses-hero__copy">
                  <h1>{hero.headline}</h1>
                  {hero.body.map((p, i) => <p key={i}>{p}</p>)}
                  {hero.cta && (
                    <Link className="ses-btn" to="/contact">
                      {hero.cta}<Arrow/>
                    </Link>
                  )}
                </div>
                <EngineeringVisual />
              </div>
            </section>

            {sections.slice(1, hasRelated ? -2 : -1).map((section, idx) => {
              const raw = section.join("\n\n");
              const blocks = splitBlocks(raw);
              const lead = blocks[0] || "";
              const firstLine = lead.split("\n")[0] || "";

              return (
                <section className={`ses-section ses-section--${idx + 2} ${idx % 2 ? "ses-section--alt" : ""}`} key={idx}>
                  <div className="ses-shell">
                    <div className="ses-section-head">
                      <span>{String(idx + 2).padStart(2, "0")}</span>
                      <h2>{firstLine}</h2>
                    </div>
                    <ContentPanel raw={raw} index={idx}/>
                  </div>
                </section>
              );
            })}

            {hasRelated && (
              <section className="ses-section ses-related">
                <div className="ses-shell">
                  <RelatedPanel raw={sections[sections.length - 2].join("\n\n")}/>
                </div>
              </section>
            )}

            <section className="ses-cta">
              <div className="ses-shell ses-two-col">
                <div className="ses-cta__copy">
                  {ctaContent.map((b, i) => {
                    const lines = b.split("\n").map((x) => x.trim()).filter(Boolean);
                    return i === 0
                      ? <h2 key={i}>{lines.join(" ")}</h2>
                      : <p key={i}>{lines.join(" ")}</p>;
                  })}

                  {ctaLabel && (
                    <Link className="ses-btn" to="/contact">
                      {ctaLabel}<Arrow/>
                    </Link>
                  )}
                </div>
                <EngineeringVisual />
              </div>
            </section>
          </main>

          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default Page;
